export class ToolOptionsPanel {
  constructor({ config, onChange, onFocus }) {
    this.config = config;
    this.onChange = onChange;
    this.onFocus = onFocus;
  }

  mount(container) {
    const panel = document.createElement("div");
    panel.className = "drawing-tool-options";

    panel.appendChild(this.createColorControl("Stroke", "strokeColor"));
    panel.appendChild(this.createColorControl("Fill", "fillColor"));
    panel.appendChild(this.createNumberControl("Line width", "lineWidth", { min: 1, max: 24, step: 1 }));
    panel.appendChild(this.createNumberControl("Dot radius", "dotRadius", { min: 1, max: 24, step: 1 }));
    panel.appendChild(this.createCheckboxControl("Fill rectangles", "rectangleFilled"));

    container.appendChild(panel);
  }

  createColorControl(labelText, key) {
    const input = document.createElement("input");
    input.type = "color";
    input.value = normalizeColorValue(this.config.toolOptions[key]);
    return this.createControl(labelText, input, key, (value) => value);
  }

  createNumberControl(labelText, key, attributes) {
    const input = document.createElement("input");
    input.type = "number";
    input.min = String(attributes.min);
    input.max = String(attributes.max);
    input.step = String(attributes.step);
    input.value = String(this.config.toolOptions[key]);
    return this.createControl(labelText, input, key, (value) => Number(value));
  }

  createCheckboxControl(labelText, key) {
    const input = document.createElement("input");
    input.type = "checkbox";
    input.checked = Boolean(this.config.toolOptions[key]);
    return this.createControl(labelText, input, key, () => input.checked, "change");
  }

  createControl(labelText, input, key, normalizeValue, eventName = "input") {
    const label = document.createElement("label");
    label.className = "drawing-tool-option";
    const text = document.createElement("span");
    text.textContent = labelText;

    input.addEventListener("focus", () => this.onFocus?.());
    input.addEventListener(eventName, () => {
      this.onChange({ [key]: normalizeValue(input.value) });
    });

    label.appendChild(text);
    label.appendChild(input);
    return label;
  }
}

function normalizeColorValue(value) {
  return typeof value === "string" && /^#[0-9a-f]{6}$/i.test(value) ? value : "#111111";
}
